import React from 'react';
import '../template-file-css/document-file-template.css';


export const EYPC_DmasCsSra = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='EYPC_DmasCsSra' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><h3>THE DEPARTMENT OF MEDICAL ASSISTANCE SERVICES <br />
                    <b>Community Stabilization (S9482) <br />
                        INITIAL Service Authorization Request Form</b></h3></center>
                    Please be mindful of notes throughout this form providing reference to where documentation obtained during the Comprehensive
                    Needs Assessment (CNA) are relevant and can be used for efficiency. <br /> <br />

                    <center><b>MEMBER INFORMATION</b></center></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Member First Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Last Name:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtMemberFirstName' name='txtMemberFirstName' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtMemberLastName' name='txtMemberLastName' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Medicaid #:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Member Date of Birth:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Gender:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtMedicaid' name='txtMedicaid' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtMemberDateOfBirth' name='txtMemberDateOfBirth' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='radio' id='rbGender_Male' name='rbGender' className='add-only' value='Male' /> Male&nbsp;
                            <input type='radio' id='rbGender_Female' name='rbGender' className='add-only' value='Female' /> Female</td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Plan ID #:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Street Address:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtMemberPlanId' name='txtMemberPlanId' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtMemberStreetAddress' name='txtMemberStreetAddress' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>City:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>State:</span></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCity' name='txtCity' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtState' name='txtState' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Zip:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Phone #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtZip' name='txtZip' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtMemberPhone' name='txtMemberPhone' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Parent/Legal Guardian Name (s):</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Parent/Legal Guardian Phone #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtParentLegalGuardian' name='txtParentLegalGuardian' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtParentLegalPhone' name='txtParentLegalPhone' className='add-only' /></td>

                    </tr>
                </table>

                <p className='w-750'><center><p><b>PROVIDER INFORMATION</b></p></center><h4></h4></p>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Organization Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Group NPI #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtOrganizationName' name='txtOrganizationName' placeholder='Empowering Youth for Positive Change' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtGroupNpi' name='txtGroupNpi' defaultValue={1538446679} className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Tax ID #:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Phone #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtProviderTax' name='txtProviderTax' defaultValue={473114954} className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtProviderPhone' name='txtProviderPhone' defaultValue={8047891314} className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider E-Mail:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Address:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtProviderEmail' name='txtProviderEmail' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtProviderAddress' name='txtProviderAddress' placeholder='101 Cowardin Avenue' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>City:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>State:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Zip:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtCity_1' name='txtCity_1' placeholder='Richmond' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtState_1' name='txtState_1' placeholder='Virginia' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtZip_1' name='txtZip_1' defaultValue={23224} className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Fax #:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone #</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtProviderFax' name='txtProviderFax' defaultValue={8044823767} className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtPhone' name='txtPhone' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Clinical Contact Name & Credentials*:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtClinicalContactName' name='txtClinicalContactName' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><b>* The individual to whom the MCO can reach out to in
                    order to gather additional necessary clinical information.</b> <br /><br />
                    Request for Approval of Services</p>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Retro Review Request?</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Data Platform Reference #</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbRetroReviewRequest_Yes' name='rbRetroReviewRequest' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbRetroReviewRequest_No' name='rbRetroReviewRequest' className='add-only' value='No' /> No </td>
                        <td className='w-375'>
                            <input type='text' id='txtDataPlatformReference' name='txtDataPlatformReference' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>If the member is currently participating in this service, start date of service:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='date' id='txtIfTheMemberisCurrentlyParticipating' name='txtIfTheMemberisCurrentlyParticipating' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><b>Proposed/Requested Service Information:</b><br />
                    From &nbsp;
                    <input type='date' id='txtProposedRequestedServiceInformation_1' name='txtProposedRequestedServiceInformation_1' className='add-only w-150 custom-add-only' /> (date), To &nbsp;
                    <input type='date' id='txtProposedRequestedServiceInformation_2' name='txtProposedRequestedServiceInformation_2' className='add-only w-150 custom-add-only' /> (date), for a total of &nbsp;
                    <input type='text' id='txtProposedRequestedServiceInformation_3' name='txtProposedRequestedServiceInformation_3' className='add-only w-100 custom-add-only' /> units of service. Plan to provide &nbsp;
                    <input type='text' id='txtProposedRequestedServiceInformation_4' name='txtProposedRequestedServiceInformation_4' className='add-only w-100 custom-add-only' /> hours of service per week
                    <br />

                    <b>Identify all known treatment periods of Community Stabilization and other behavioral health services that have
                        been provided by any providers including the requesting provider in the past 30 calendar days:
                        <br /></b></p>

                <table>
                    <tr>
                        <td className='w-200'>
                            <span className='eleHeader'>Provider<br />&nbsp;</span></td>
                        <td className='w-150'>
                            <span className='eleHeader'>Dates of Service/Intervention </span></td>
                        <td className='w-400'>
                            <span className='eleHeader'>Outcomes<br />&nbsp;</span></td>

                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id='txtProvider_1' name='txtProvider_1' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDatesOfSeviceIntervention_1' name='txtDatesOfSeviceIntervention_1' className='add-only' /></td>
                        <td className='w-400'>
                            <input type='text' id='txtOutcomes_1' name='txtOutcomes_1' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id='txtProvider_2' name='txtProvider_2' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDatesOfSeviceIntervention_2' name='txtDatesOfSeviceIntervention_2' className='add-only' /></td>
                        <td className='w-400'>
                            <input type='text' id='txtOutcomes_2' name='txtOutcomes_2' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id='txtProvider_3' name='txtProvider_3' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDatesOfSeviceIntervention_3' name='txtDatesOfSeviceIntervention_3' className='add-only' /></td>
                        <td className='w-400'>
                            <input type='text' id='txtOutcomes_3' name='txtOutcomes_3' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id='txtProvider_4' name='txtProvider_4' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDatesOfSeviceIntervention_4' name='txtDatesOfSeviceIntervention_4' className='add-only' /></td>
                        <td className='w-400'>
                            <input type='text' id='txtOutcomes_4' name='txtOutcomes_4' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Primary ICD-10 Diagnosis</span>
                    <input type='text' id='txtPrimaryDiagnosis' name='txtPrimaryDiagnosis' className='add-only' /> <br />

                    <span className='eleHeader'>Secondary Diagnosis(es)</span>
                    <input type='text' id='txtSecondaryDiagnosis' name='txtSecondaryDiagnosis' className='add-only' /> <br /><br />

                    <span className='eleHeader'>Other medical/behavioral health concerns (including substance use issues, personality disorders, dementia,
                        cognitive impairments) that could impact services? </span>
                    <input type='radio' id='rbOtherMedicalBehavioralHealth_Yes' name='rbOtherMedicalBehavioralHealth' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbOtherMedicalBehavioralHealth_No' name='rbOtherMedicalBehavioralHealth' className='add-only' value='No' /> No  <br />
                    <b> (If yes, explain below.)</b><br />
                    <textarea id='txtIfYesExplainBelow' name='txtIfYesExplainBelow' className='add-only'></textarea></p>

                <p className='w-750'><center><h4><b>SECTION I: ADMISSION CRITERIA</b></h4></center>
                    <b>Individuals must meet ALL of the following criteria; note that some criteria have multiple sub-criteria for
                        consideration</b> <br />
                    <span className='eleHeader'>1. Specify the DSM diagnosis or provisional diagnosis corresponding with the ICD-10 diagnosis(es).</span>
                    <textarea id='txtSpecifyTheDiagnosis' name='txtSpecifyTheDiagnosis' className='add-only'></textarea> <br />

                    <span className='eleHeader'>Describe the individual's current symptoms (including frequency, intensity and duration) and areas of functional
                        impairment. Corresponding CNA Elements: 1, 6, 7, 12</span>
                    <textarea id='txtDescribeTheIndividualsCurrent' name='txtDescribeTheIndividualsCurrent' className='add-only'></textarea> <br />

                    <span className='eleHeader'>2. The individual has demonstrated a level of acuity indicating that they are at risk for crisis-cycling or dangerous
                        decompensation in functioning and additional support in the form of Community Stabilization is required to prevent
                        an acute inpatient admission. Is the individual able to sustain safety during the interim period between services, if
                        not, why? Describe any repeated occurrences of behaviors that are endangering to self or others, are difficult to
                        control, cause distress, or other evidence that the individual is at risk of crisis-cycling or dangerous decompensation
                        and an acute inpatient admission.</span>
                    <textarea id='txtTheIndividualHasDemostratedLevel' name='txtTheIndividualHasDemostratedLevel' className='add-only'></textarea> <br /> </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>3. Prior to admission the individual must meet either <b>a. or b. below:</b></span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>a.</b> The individual is residing in a Therapeutic Group Home (TGH) or ASAM 3.1. Please provide TGH provider name, address and clinical contact information
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbTheIndividualIsResidingInTherapeutic_Yes' name='rbTheIndividualIsResidingInTherapeutic' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbTheIndividualIsResidingInTherapeutic_No' name='rbTheIndividualIsResidingInTherapeutic' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Address:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtProviderName_1' name='txtProviderName_1' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtProviderAddress_1' name='txtProviderAddress_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinical Contact Name:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinical Contact Phone:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinical Contact Email:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtClinicalContactName' name='txtClinicalContactName' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtClinicalContactPhone' name='txtClinicalContactPhone' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtClinicalContactEmail' name='txtClinicalContactEmail' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Note:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtNote' name='txtNote' className='add-only'></textarea></td>
                    </tr>
                </table>

                <p className='w-750'><b>If yes, skip to Section II: Other Required Information</b></p>


                <table>

                    <tr>
                        <td className='w-750'>
                            <b>b.</b> The individual needs Community Stabilization as a transition service. <b>Must meet criteria i or ii:</b> <br /> <br />
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>i.</b> A Licensed Mental Health Professional (LMHP), LMHP-R, LMHP-RP or LMHP-S at a
                            Community Services Board (CSB) same day access intake, a Managed Care Organization, or
                            Fee-For-Service contractor determines Community Stabilization is needed to support a
                            transition in care and link an individual to appropriate services. Please provide provider
                            name, address, clinical contact information for the identified LMHP.</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbTheIndividualNeedsCommunityStabilization_Yes' name='rbTheIndividualNeedsCommunityStabilization' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbTheIndividualNeedsCommunityStabilization_No' name='rbTheIndividualNeedsCommunityStabilization' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Address:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtProviderName_2' name='txtProviderName_2' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtProviderAddress_2' name='txtProviderAddress_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>LMHP Contact Name:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>LMHP Contact Phone:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>LMHP Contact Email:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtLmhpContactName' name='txtLmhpContactName' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtLmhpContactPhone' name='txtLmhpContactPhone' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtLmhpContactEmail' name='txtLmhpContactEmail' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Note:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtNote_1' name='txtNote_1' className='add-only'></textarea></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>ii.</b>The individual is being discharged from one of the below services:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type='radio' id='rbTheIndividualBeingDischarged_Yes' name='rbTheIndividualBeingDischarged' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbTheIndividualBeingDischarged_No' name='rbTheIndividualBeingDischarged' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <select id='ddlTheIndividualBeingDischarged' name='ddlTheIndividualBeingDischarged' className='add-only'>
                                <option value='Hour'>(a) 23-Hour Crisis Stabilization</option>
                                <option value='Acute'>(b) Acute Psychiatric Inpatient Services </option>
                                <option value='Levels'>(c) ASAM levels 3.1 - 4.0</option>
                                <option value='Hospital'>(d) Hospital Emergency Department</option>
                                <option value='ShortTerm'>(e) Short-term detention or incarceration</option>
                                <option value='Mobile'>(f) Mobile Crisis Response</option>
                                <option value='Partial'>(g) Partial Hospitalization Program (Mental Health or ARTS)</option>
                                <option value='Psychiatric'>(h) Psychiatric Residential Treatment Facility </option>
                                <option value='Residential'>(i) Residential Crisis Stabilization Unit</option>
                                <option value='Therapeutic'>(j) Therapeutic Group Home</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Please provide provider/agency name, address, clinical contact information for the identified
                            professional coordinating the discharge plan</b>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Address:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtProviderName_3' name='txtProviderName_3' placeholder='Empowering Youth for Positive Change' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtProviderAddress_3' name='txtProviderAddress_3' placeholder='101 Cowardin Avenue Richmond Virginia 23224' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Contact Name:</span></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtContactName' name='txtContactName' placeholder='Dr. Reginald Wells, Ph. D, LPC, CPCS, LPC- Supervisor' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Contact Phone:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Contact Email:</span></td>
                    </tr>
                    <tr>

                        <td className='w-375'>
                            <input type='text' id='txtContactPhone' name='txtContactPhone' placeholder='4703889707' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtContactEmail' name='txtContactEmail' placeholder='reginald.wells@ey4pc.com' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Note:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtNote_2' name='txtNote_2' className='add-only'></textarea></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>iii.</b>Individuals meeting either criteria i. or criteria ii. above must also meet the following additional criteria:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>a.</b> The service that the individual needs and is recommended by a professional listed in item i. above or a
                            professional coordinating the discharge plan from services listed in item ii. above is not currently
                            available for immediate access. What is the intended service (name and procedure code) and what are
                            the barriers to immediate availability? <br />
                            <input type='radio' id='rbTheServiceThatTheIndividual_Yes' name='rbTheServiceThatTheIndividual' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbTheServiceThatTheIndividual_No' name='rbTheServiceThatTheIndividual' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Name and Procedure Code of
                            identified Behavioral Health service:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtNameAndProcedureCode' name='txtNameAndProcedureCode' placeholder='Community Stabilization (S9482)' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtNameAndProcedure' name='txtNameAndProcedure' placeholder=' There are no barriers.' className='add-only'></textarea>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><b>b.</b> A clinically appropriate and specific behavioral health service provider referral(s) has been identified and
                            a plan for the timeline of transition from Community Stabilization to that provider has been established
                            and documented. Provide details about the transition plan: specific dates and times for the assessment
                            or start of service, and any details about transition sessions. <br />
                            <input type='radio' id='rbClinicallyAppropriateSpecific_Yes' name='rbClinicallyAppropriateSpecific' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbClinicallyAppropriateSpecific_No' name='rbClinicallyAppropriateSpecific' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Name/Agency:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Address:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtProviderName_4' name='txtProviderName_4' placeholder='Empowering Youth for Positive Change' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtProviderAddress_4' name='txtProviderAddress_4' placeholder='101 Cowardin Avenue Richmond Virginia 23224' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Contact Name:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtContactName_1' name='txtContactName_1' placeholder='Dr. Reginald Wells, Ph. D, LPC, CPCS, LPC- Supervisor' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Contact Phone</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Contact Phone</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtContactPhone_1' name='txtContactPhone_1' placeholder='470-388-9707' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtContactEmail_1' name='txtContactEmail_1' placeholder='reginald.wells@ey4pc.co' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Note:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtNote_3' name='txtNote_3' className='add-only'></textarea></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>If the timeline for this transition (#iii,b) exceeds 2 weeks, the Community Stabilization provider has documented
                                communications with additional, specific service providers to support additional service options or potentially
                                faster access to the recommended service type. Please provide additional referral information, service type/
                                procedure code, provider and contact information (if applicable).
                            </span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtIfTheTimelineForThisTransition' name='txtIfTheTimelineForThisTransition' className='add-only'></textarea></td>
                    </tr>
                </table>

                <p className='w-750'><center><h4><b>Section II: OTHER REQUIRED INFORMATION</b></h4></center>
                    <b>Along with this document, please include the following with your submission (if applicable):</b> <br /><br />
                    <b>If criteria (#3,b,i) is met submit the following:</b> <br />

                    1. Documented referral from the Community Services Board (CSB) same day access intake, a Managed Care
                    Organization, or Fee-For-Service contractor. The referral must include the name of both the referring provider and
                    the Community Stabilization provider  <br /> <br />

                    <b>If criteria (#3,b,ii) is met, submit the following:</b> <br />

                    2. Documented referral from discharging provider/agency. The referral must include the name of both the referring
                    provider/agency and the Community Stabilization provider <br /><br />

                    By my signature (below), I am attesting that 1) an LMHP, LMHP-R, LMHP-S or LMHP-RP has reviewed the individual's
                    psychiatric history and completed the appropriate assessment or addendum; and 2) that this assessment indicates
                    that the individual meets the medical necessity criteria for the identified service. The assessment or applicable
                    addendum for this service was completed on the following date:
                    <input type='date' id='txtByMySignature_1' name='txtByMySignature_1' className='add-only w-200 custom-add-only' /></p>

                <table>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'>Signature (actual or electronic) of LMHP (Or R/S/RP):</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Printed Name of LMHP (Or R/S/RP):</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Credentials:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPrintedNameOfLmhp' name='txtPrintedNameOfLmhp' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtCredentials' name='txtCredentials' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>NPI #:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtNpi' name='txtNpi' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='date' id='txtDate' name='txtDate' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Note:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtNote_4' name='txtNote_4' className='add-only'></textarea></td>
                    </tr>
                </table>































            </div >
        </form >

    )
}











